/**************************************************************************
Name:         main.js
Description:  Site scripting.
Date Created: 09/27/2012 by Kyle Brickman
Modified:     12/07/2013 by Roxanne Martinez
**************************************************************************/

/* Site navigation */
loadEvents.push( function( )
{

	var nav = {
		inputClick   : 'click',
		inputUp      : window.PointerEvent ? 'pointerup'    : window.MSPointerEvent ? 'MSPointerUp'    : 'mouseup touchend touchcancel',
		inputEnter   : window.PointerEvent ? 'pointerenter' : window.MSPointerEvent ? 'MSPointerEnter' : 'mouseover touchstart',
		inputMove    : window.PointerEvent ? 'pointermove'  : window.MSPointerEvent ? 'MSPointerMove'  : 'mousemove touchmove',

		isStockAndroid : null != navigator.userAgent.toLowerCase( ).match( /android/ ) &&
		                 null == navigator.userAgent.toLowerCase( ).match( /chrome/  ) &&
		                 null == navigator.userAgent.toLowerCase( ).match( /firefox/ ) &&
		                 null == navigator.userAgent.toLowerCase( ).match( /opera/   ),

		calculate : function( )
		{
			/* Landscape */
			var padding = ( $( window ).width( ) - $( '.accountActions .grid' ).width( )) / 2;
			$( 'header.landscape .flexnav nav' ).css( 'padding', '0 ' + padding + 'px' );
			$( '.screenReaderSkipper' ).css( 'margin-left', (padding + 25) + 'px' );

			$( 'header.landscape .flexnav nav ul.secondary li' ).each( function( ){
				var item = $( this ),
					itemHeight;

				item.removeClass( 'animated' );
				item.removeAttr( 'data-height style' );
				itemHeight = item.outerHeight( ) + 25;
				item.attr( 'data-height', itemHeight);
				item.css( 'height', ( item.hasClass( 'hover' ) ? itemHeight : '0' ) + 'px' );
				setTimeout( function( ){ item.addClass( 'animated' ); }, 100 );
			});

			/* Portrait */
			$( 'header.portrait' ).css( 'max-height', $( window ).height( ) + 'px' );
			if( $( 'header.portrait div.error' ).hasClass( 'active' ) ) {
				$( 'header.portrait div.error' ).css( 'height', $( 'header.portrait div.error div' ) + 25 + 'px' );
			}

			//nav.hideLandscape( );
			//if( $( 'header.portrait div.login input:focus' ).length == 0 && $( 'header.portrait div.signup input:focus' ).length == 0 )
					//nav.hidePortrait(  );

			if( 'none' == $( 'header.landscape' ).css( 'display' )){ nav.hideLandscape( ); $( 'div.curtain' ).css('filter','0').fadeOut().css('filter',"progid:DXImageTransform.Microsoft.gradient( startColorstr='#80000000', endColorstr='#80000000',GradientType=0 )"); }
			if( 'none' == $( 'header.portrait'  ).css( 'display' )) nav.hidePortrait(  );
		},

		trap : function( evt )
		{
			evt.preventDefault( );

			var link  = $( this );
			var bound = $( 'header.landscape .flexnav nav ul.secondary li[data-pid="' + link.attr( 'data-pid' ) + '"]' );

			if( !bound.length || 'true' == link.attr( 'data-trap' ))
			{
				window.location = link.attr( 'href' );
				return;
			}

			link.attr( 'data-trap', 'false' );
		},

		setTrap : function( )
		{
			var link  = $( this );

			link.attr( 'data-trap', 'true' );
		},

		showLandscape : function( evt )
		{
			var link  = $( this );
			var bound = $( 'header.landscape .flexnav nav ul.secondary li[data-pid="' + link.attr( 'data-pid' ) + '"]' );

			if( link.hasClass( 'hover' ))
				return;

			nav.hideLandscape( );

			link.attr( 'data-trap', 'false' );

			link.addClass(  'hover' );
			bound.addClass( 'hover' );
			bound.css( 'height', bound.attr( 'data-height' ) + 'px' );
			$( 'header.landscape .flexnav' ).css( 'height', ( parseInt( bound.attr( 'data-height' )) + 136 ) + 'px' );

			if(( window.navigator.msPointerEnabled && 'mouse' != evt.originalEvent.pointerType ) || 'touchstart' == evt.type || nav.isStockAndroid )
			{
				link.off( nav.inputUp, nav.setTrap );
				link.one( nav.inputClick, function( ){
					link.on( nav.inputUp, nav.setTrap );
					link.trigger( nav.inputUp );
				});
			}
		},

		showLandscapeParent : function(evt)
		{
			var bound = $( this );
			var boundParent = $(bound).closest('li.secondaryNavPoint')
			var link  = $('header.landscape .flexnav nav ul.primary a[data-pid="'+boundParent.attr('data-pid')+'"]');

			if( link.hasClass( 'hover' ))
				{
				return;
				};

			nav.hideLandscape( );

			link.attr( 'data-trap', 'false' );

			link.addClass(  'hover' );
			boundParent.addClass( 'hover' );
			boundParent.css( 'height', boundParent.attr( 'data-height' ) + 'px' );
			$( 'header.landscape .flexnav' ).css( 'height', ( parseInt( boundParent.attr( 'data-height' )) + 136 ) + 'px' );

			if(( window.navigator.msPointerEnabled && 'mouse' != evt.originalEvent.pointerType ) || 'touchstart' == evt.type || nav.isStockAndroid )
			{
				link.off( nav.inputUp, nav.setTrap );
				link.one( nav.inputClick, function( ){
					link.on( nav.inputUp, nav.setTrap );
					link.trigger( nav.inputUp );
				});
			}
		},

		hideLandscape : function( evt )
		{
			var link  = $( 'header.landscape .flexnav nav ul.primary a.hover' );
			var bound = $( 'header.landscape .flexnav nav ul.secondary li[data-pid="' + link.attr( 'data-pid' ) + '"]' );

			if( evt && $( 'header.landscape .flexnav nav ul.primary a.hover, header.landscape .flexnav nav ul.secondary, header.landscape .flexnav nav ul.secondary *' ).filter( evt.target ).length )
				return;

			link.removeAttr( 'data-trap' );

			link.removeClass(  'hover' );
			bound.removeClass( 'hover' );
			bound.css( 'height', '0px' );
			$( 'header.landscape .flexnav' ).css( 'height', '' );
		},

		showPortrait : function( evt )
		{
			evt.preventDefault( );

			if( !$( 'header.portrait' ).hasClass( 'active' ))
			{
				$( 'header.portrait' ).addClass( 'active' );
				$( 'body' ).addClass( 'portraitActive' );
				$('html').css("overflow", "hidden");
			}
			else
				nav.hidePortrait( );
		},

		hidePortrait : function( evt )
		{

			if( evt && $( 'header.portrait, header.portrait *' ).filter( evt.target ).length )
				return;

			$( 'header.portrait' ).removeClass( 'active' );
			$( 'body' ).removeClass( 'portraitActive' );
			$('html').css("overflow-y", "auto");

			nav.collapseLogin( );
			nav.collapseSignup( );

			$('<style></style>').appendTo($(document.body)).remove();

			$( 'header.portrait ul li[data-pid]:not([data-parentid])' ).each( function( ){
				nav.collapseRow( $( this ));
			});

		},

		expandRow : function( row )
		{
			row.addClass( 'expanded' );
			$( 'a.toggle', row ).attr( 'title', 'View Less' );

			$( 'header.portrait ul li[data-parentid="' + row.attr( 'data-pid' ) + '"]' ).removeClass( 'collapsed' );
		},

		collapseRow : function( row )
		{
			row.removeClass( 'expanded' );
			$( 'a.toggle', row ).attr( 'title', 'View More' );

			$( 'header.portrait ul li[data-parentid="' + row.attr( 'data-pid' ) + '"]' ).each( function( ){
				$( this ).addClass( 'collapsed' );
				nav.collapseRow( $( this ));
			});
		},

		toggleRow : function( evt )
		{
			evt.preventDefault( );

			var toggle = $( this );
			var row    = $( this ).parent( );

			if( row.hasClass( 'expanded' ))
				nav.collapseRow( row );
			else
				nav.expandRow( row );
		},

		expandLogin : function( )
		{
			nav.collapseSignup( );

			var link      = $( 'header.portrait div.account a.login' );
			var login     = $( 'header.portrait div.login' );

			login.addClass( 'active' );
			 link.addClass( 'active' );
			// login.find( 'input[type="text"]' ).first( ).focus( );
		},

		collapseLogin : function( )
		{
			var link      = $( 'header.portrait div.account a.login' );
			var login     = $( 'header.portrait div.login' );

			login.removeClass( 'active' );
			 link.removeClass( 'active' );

			nav.collapseError( );
		},

		toggleLogin : function( evt )
		{
			evt.preventDefault( );

			var login = $( this );

			if( login.hasClass( 'active' ))
				nav.collapseLogin( );
			else
				nav.expandLogin( );
		},

		expandSignup : function( )
		{
			nav.collapseLogin( );

			var link      = $( 'header.portrait div.account a.signup' );
			var signup     = $( 'header.portrait div.signup' );

			signup.addClass( 'active' );
			 link.addClass( 'active' );
		},

		collapseSignup : function( )
		{
			var link      = $( 'header.portrait div.account a.signup' );
			var signup     = $( 'header.portrait div.signup' );

			signup.removeClass( 'active' );
			link.removeClass( 'active' );

			nav.collapseError( );
		},

		toggleSignup : function( evt )
		{
			evt.preventDefault( );

			var signup = $( this );

			if( signup.hasClass( 'active' ))
				nav.collapseSignup( );
			else
				nav.expandSignup( );
		},

		expandError : function( )
		{
			$( 'header.portrait div.error' ).addClass( 'active' ).css( 'height', $( 'header.portrait div.error' ).height( ) + 'px' );
		},

		collapseError : function( )
		{
			$( 'header.portrait div.error' ).removeClass( 'active' ).css( 'height', 0 );
		},

		setLoginError : function( text )
		{
			$( 'header.portrait div.error div span:first-child' ).text( text );
		},

		init : function( )
		{
			var self = this;

			self.calculate( );

			$( window ).on( 'resize orientationchange', self.calculate );

			$( 'header.landscape .flexnav nav ul.primary a' ).on( self.inputClick, self.trap          );
			$( 'header.landscape .flexnav nav ul.primary a' ).on( self.inputUp,    self.setTrap       );
			$( 'header.landscape .flexnav nav ul.primary a' ).on( self.inputEnter, self.showLandscape );

			$( 'header.landscape .flexnav nav ul.primary a' ).on( 'focus', self.showLandscape );
			//trigger when tabbing through secondary links in the nav
			$( 'header.landscape .flexnav nav ul.secondary a' ).on( 'focus', self.showLandscapeParent );
			// Remove focus on the home tab when reverse-tabbing through the nav.
			$('.homeTab').on('blur', function(){
				$('.homeTab').removeClass('hover');
			});
			// If the last nav link loses focus, check  whether or not any of the other nav items have focus. If not, then close the nav
			$('.lastLink').on('blur', function(evt){
				if($('li.secondaryNavPoint div a').is(":focus"))
				{
					return;
				}
				else
				{
					$('.primaryNavPoint').removeClass('hover');
					$('.secondaryNavPoint').removeClass('hover');
					self.hideLandscape();
				}
			});



			$( 'header.portrait a.menu'              ).on( self.inputClick, self.showPortrait );
			$( 'header.portrait div.account a.login' ).on( self.inputClick, self.toggleLogin  );
			$( 'header.portrait ul li a.toggle'      ).on( self.inputClick, self.toggleRow    );

			$( 'header.portrait div.account a.signup' ).on( self.inputClick, self.toggleSignup  );
			$('header.landscape .flexnav nav ul.secondary li:last-child div:last-child a:last-child').on('focusout', self.hideLandscape);

			$( 'body' ).on( self.inputUp + ' ' + self.inputMove, self.hideLandscape );
			$( 'body' ).on( self.inputUp, self.hidePortrait );
			$('div.section.main').on('keypress',self.hideLandscape);



		}
	}
	nav.init( );
});

/* Other load events */
loadEvents.push( function( ){
	/*Accessibility Focus*/
	$('body').on('keyup', function(evt) {
		if(evt.keyCode == 9) {
			$('.cta.showHideBox').each(function() {
				var cta 	  = $(this);
				var ctaHeader = cta.find('.ctaHeader');
				var ctaDesc   = cta.find('.ctaDesc');
				var ctaFocus  = cta.find('a:focus').length;

				if(ctaFocus > 0 && !ctaHeader.hasClass('active')) {
					ctaHeader.addClass('active');
					ctaDesc.addClass('active');
				}
				else if(ctaFocus <= 0 && cta.hasClass('active')) {
					ctaHeader.addClass('active');
					ctaDesc.addClass('active');
				}
				else if(ctaFocus <= 0 && ctaHeader.hasClass('active')){
					ctaHeader.removeClass('active');
					ctaDesc.removeClass('active');
				}
			});

		}
	});

	/* Modal functions */
	$( 'div.curtain' ).css( { display : 'block', opacity : '0' } );
	var signupModalHeight = $( 'div.curtain.signup div.modal' ).height( );
	var loginModalHeight = $( 'div.curtain.login div.modal' ).height( );
	$( 'div.curtain' ).css( { display : 'none', opacity : '1' } );
	$( 'div.curtain.signup div.modal' ).css( { marginTop : '-' + signupModalHeight + 'px' });
	$( 'div.curtain.login div.modal' ).css( { marginTop : '-' + loginModalHeight + 'px' });

	$('div.ctaOverLink').click(function(evt) {
		if( $( this ).attr('data-target') == "_blank" ) {
			window.open($( this ).attr('data-href'), '_blank');
		} else {
			window.location.href = $( this ).attr('data-href');
		}
	});

	// $('li.secondaryNavPoint > div > a').focus(function(evt){
	// 	var secondaryPID = $(this).closest('li.secondaryNavPoint').attr('data-pid');
	// 	console.log(secondaryPID);
	// 	if(!$(this).closest('li[data-pid="'+secondaryPID+'"').hasClass('hover')){
	// 		$('.secondaryNavPoint').removeClass('hover');
	// 		$('.primaryNavPoint').removeClass('hover');
	// 		$('li[data-pid="'+secondaryPID+'"').addClass('hover');
	// 		$('a[data-pid="'+secondaryPID+'"').addClass('hover');
	// 	}
	// });

	$( 'div.curtain' ).click( function( evt ){
		if( $( this ).hasClass( 'signup' ) ){
			$( this ).find( 'div.modal' ).animate( { marginTop : '-' + signupModalHeight + 'px' }, 400 );
		}else if( $( this ).hasClass( 'login' ) ){
			$( this ).find( 'div.modal' ).animate( { marginTop : '-' + loginModalHeight + 'px' }, 400 );
		}
		$( this ).css('filter','0').fadeOut().css('filter',"progid:DXImageTransform.Microsoft.gradient( startColorstr='#80000000', endColorstr='#80000000',GradientType=0 )");
	});

	$( 'div.modal' ).click( function( evt ){
		evt.stopPropagation( );
	});

	$( 'div.modal input[type="button"].close' ).click(function(){
		if( $( this ).closest( 'div.curtain' ).hasClass( 'signup' ) ){
			$( this ).closest( 'div.modal' ).animate( { marginTop : '-' + signupModalHeight + 'px' }, 400 );
		}else if( $( this ).closest( 'div.curtain' ).hasClass( 'login' ) ){
			$( this ).closest( 'div.modal' ).animate( { marginTop : '-' + loginModalHeight + 'px' }, 400 );
		}
		$( this ).closest( 'div.curtain' ).css('filter','0').fadeOut().css('filter',"progid:DXImageTransform.Microsoft.gradient( startColorstr='#80000000', endColorstr='#80000000',GradientType=0 )");
	});

	if( showMaintenance == 0 )
	{
		$( 'div.accountActions a.signupLink' ).click(function( evt ){
			evt.preventDefault( );
			if( $( window ).width() < 1200 ){
				$( 'div.curtain.signup div.column.span_4_12' ).css( { 'min-width': '400px' } );
				$( 'div.curtain.signup div.grid' ).css( { 'min-width': $( window ).width() + 'px', 'width': $( window ).width() + 'px' } );
			}else{
				$( 'div.curtain.signup div.column.span_4_12' ).css( { 'min-width': '0' } );
				$( 'div.curtain.signup div.grid' ).css( { 'min-width': '1200px', 'width': '1200px' } );
			}
			$( 'div.curtain.signup div.modalWrapper').css('height', $(window).height() + 'px');
			$( 'div.curtain.signup div.modal' ).animate( { marginTop: 0 }, 400, function(){updateModalScroll( $( 'div.curtain.signup' ) ); });
			$( 'div.curtain.signup' ).css('filter','0').fadeIn().css('filter',"progid:DXImageTransform.Microsoft.gradient( startColorstr='#80000000', endColorstr='#80000000',GradientType=0 )");
			$('#company1').focus();
			//$( 'div.curtain.signup input[type="text"]' ).first( ).focus( );
		});
	}

	if( showMaintenance == 0 )
	{
		$( 'div.accountActions a.loginLink' ).click(function( evt ){
			evt.preventDefault( );
			if( $( window ).width() < 1200 ){
				$( 'div.curtain.login div.column.span_4_12' ).css( { 'min-width': '300px' } );
				$( 'div.curtain.login div.grid' ).css( { 'min-width': $( window ).width() + 'px', 'width': $( window ).width() + 'px' } );
			}else{
				$( 'div.curtain.login div.column.span_4_12' ).css( { 'min-width': '0' } );
				$( 'div.curtain.login div.grid' ).css( { 'min-width': '1200px', 'width': '1200px' } );
			}
			$( 'div.curtain.login div.modalWrapper').css('height', $(window).height() + 'px');
			$( 'div.curtain.login div.modal' ).animate( { marginTop: 0 }, 400, function(){updateModalScroll( $( 'div.curtain.login' ) ); });
			$( 'div.curtain.login' ).css('filter','0').fadeIn().css('filter',"progid:DXImageTransform.Microsoft.gradient( startColorstr='#80000000', endColorstr='#80000000',GradientType=0 )");
			$('#unCurtain').focus();
			//$( 'div.curtain.login input[type="text"]' ).first( ).focus( );
		});
	}

	var signupBasicSubmit = function( evt )
	{
		//var formObj = $( 'div.curtain.signup div.modal form' );
		var formObj = $( this ).closest( 'form' );
		var formSection = formObj.attr( 'data-section' ); //signupCurtain or signupPortrait

		var company = formObj.find( 'input[name="company"]' );
		var fname   = formObj.find( 'input[name="fname"]' );
		var lname   = formObj.find( 'input[name="lname"]' );
		var email   = formObj.find( 'input[name="email"]' );
		var companyErr = "";
		var fnameErr = "";
		var lnameErr = "";
		var emailErr = "";
		var captchaErr = "";
		var mobileMsgErr = "";
		var captchaTest = formObj.find( 'input[name="captchaTest"]' );
		var toSubmit = formObj.serialize();
		var numErrors = 0;
		evt.preventDefault();

		var loadingIcon = $('<span class="loadingIcon signup"></span>');

		email.after(loadingIcon);
		loadingIcon.addClass('active');

		if( formSection == 'signupCurtain' )
		{
			//Modal
			formObj.find( 'div.error' ).fadeOut().remove();
		}
		else
		{
			//Portrait
			$( 'header.portrait div.error' ).removeClass( 'active' ).css( 'height', 0 );
		}

		if( formObj.find( 'div.audioplayer audio' ).length ) try{ formObj.find( 'div.audioplayer audio' ).get( 0 ).pause() } catch( err ){ /* GNDN */ };
		formObj.find( 'div.audioplayer' ).empty();

		$.ajax({
			url      : '/cfcs/contactDAO.cfc',
			cache    : false,
			dataType : 'json',
			data     : toSubmit + '&method=signupStep1AJAX',
			success  : function( result ){
				if( jQuery.type( result.ERROR.COMPANY ) === 'undefined' ){ company.removeAttr('error'); }else{ numErrors++; company.attr('error',''); companyErr = "<li>Please enter your full company name</li>"; mobileMsgErr = mobileMsgErr.concat(' "Company Name"'); }
				if( jQuery.type( result.ERROR.FNAME ) === 'undefined' ){ fname.removeAttr('error'); }else{ numErrors++; fname.attr('error',''); fnameErr = "<li>Please enter your first name</li>"; mobileMsgErr = mobileMsgErr.concat(' "First Name"');}
				if( jQuery.type( result.ERROR.LNAME ) === 'undefined' ){ lname.removeAttr('error'); }else{ numErrors++; lname.attr('error',''); lnameErr = "<li>Please enter your last name</li>"; mobileMsgErr = mobileMsgErr.concat(' "Last Name"');}
				if( jQuery.type( result.ERROR.EMAIL ) === 'undefined' ){ email.removeAttr('error'); }else{ numErrors++; email.attr('error',''); emailErr = "<li>Please enter your email</li>"; mobileMsgErr = mobileMsgErr.concat(' "Email"');}
				if( jQuery.type( result.ERROR.CAPTCHATEST ) === 'undefined' ){ captchaTest.removeAttr('error'); }else{ numErrors++; captchaTest.attr('error',''); var captchaErr = "<li>Please enter the captcha</li>"; mobileMsgErr = mobileMsgErr.concat(' "Captcha"');}
				if( numErrors == 0 ){
					// go to next step of sign up
					signUpSearch( formObj );
				}else{
					loadingIcon.remove();

					formObj.find( 'div.fayt' ).remove();
					formObj.find( 'a.audioControl' ).remove();
					getSignupCaptcha( formObj );

					var msgTxt = 'Please correct the fields marked in orange below to continue.';
					if( company.val().length > 0 && company.val().length < 3 ) msgTxt = msgTxt.concat( ' Please enter your full company name.' );

					if( formSection == 'signupCurtain' )
					{
						//Show modal error
						var msg = $( '<div class = "error hiddenError">' + msgTxt + '<ul>' + companyErr + fnameErr + lnameErr + emailErr + captchaErr + '</ul></div>' );
						formObj.find('legend').after( msg );
						msg.animate({ 'max-height':'1000px', 'opacity':'1', 'padding-top':'5px', 'padding-bottom':'5px' },500,function(){ updateModalScroll( $( 'div.curtain.signup' ) ); });
					}
					else
					{
						//Show portrait error
						$('*').animate({ scrollTop: 0 }, 0);
						msgTxt = "Please correct the following fields:"
						msgTxt = msgTxt.concat(mobileMsgErr);
						$( 'header.portrait div.error div' ).html( msgTxt );
						$( 'header.portrait div.error' ).addClass( 'active' ).css( 'height', $( 'header.portrait div.error div' ).height( ) + 25 + 'px' );
					}
				}
			},
			failure  : function( ){
				window.location = '/myusapeec/signupbasic/';
			}
		});
	}

	var signupSearchSubmit = function( evt )
	{
		//var formObj = $( 'div.curtain.signup div.modal form' );
		var formObj = $( this ).closest( 'form' );
		var formSection = formObj.attr( 'data-section' ); //signupCurtain or signupPortrait

		var selected = formObj.find('input[type="radio"][name="organizationUUID"]:checked');
		var toSubmit = formObj.serialize();
		evt.preventDefault();

		if( formSection == 'signupCurtain' )
		{
			//Modal
			formObj.find( 'div.error' ).fadeOut().remove();
		}
		else
		{
			//Portrait
			$('*').animate({ scrollTop: 0 }, 0);
			$( 'header.portrait div.error' ).removeClass( 'active' ).css( 'height', 0 );
		}

		$.ajax({
			url      : '/cfcs/contactDAO.cfc',
			cache    : false,
			dataType : 'json',
			data     : toSubmit + '&method=signupStep2AJAX',
			success  : function( result ){

				if( jQuery.type( result.ERROR.ORGANIZATIONID ) !== 'undefined' )
				{
					if( jQuery.type( result.ERROR.MSG ) === 'undefined' )
					{
						var msgTxt = 'Please select your company to continue.';
					} else
					{
						var msgTxt = result.ERROR.MSG;
					}

					if( formSection == 'signupCurtain' )
					{
						//Show modal error
						var msg = $( '<div class = "error hiddenError">' + msgTxt + '</div>' );
						formObj.find('legend').after( msg );
						msg.animate({ 'max-height':'1000px', 'opacity':'1', 'padding-top':'5px', 'padding-bottom':'5px' },500,function(){ updateModalScroll( $( 'div.curtain.signup' ) ); });
					}
					else
					{
						//Show portrait error
						$( 'header.portrait div.error div' ).html( msgTxt );
						$( 'header.portrait div.error' ).addClass( 'active' ).css( 'height', $( 'header.portrait div.error div' ).height( ) + 25 + 'px' );
					}

				} else
				{
					// go to next step of sign up
					//$( 'div.curtain.signup div.modal form' ).unbind( 'submit' ).attr('action','/myusapeec/signupsearch/').submit();
					formObj.unbind( 'submit' ).attr('action','/myusapeec/signupsearch/').submit();
				}
			},
			failure  : function( ){
				window.location = '/myusapeec/signupsearch/';
			}
		});
	}

	var updateModalScroll = function( modalCurtainObj )
	{
		if( modalCurtainObj.find( 'div.modal' ).height() > $(window).height() )
		{
			modalCurtainObj.find( 'div.modalWrapper').addClass( 'scroll' );
		}else{
			modalCurtainObj.find( 'div.modalWrapper').removeClass( 'scroll' );
		}
	}

	var signUpSearch = function( formObj )
	{
		var formSection = formObj.attr( 'data-section' ); //signupCurtain or signupPortrait


		if( formSection == 'signupPortrait' )
			$('*').animate({ scrollTop: 0 }, 0);

		$.ajax({
			url      : '/myusapeec/signupsearch/',
			cache    : false,
			dataType : 'html',
			success  : function( result ){
				var formToInsert = $( result ).find('article.mainContent form fieldset');
				if( formToInsert.html() == 'redirect' ){
					window.location = '/myusapeec/signupoperating/';
				}else{


					if( formSection == 'signupCurtain' )
					{
						//modal
						formObj.find('fieldset.signup').remove();
						formToInsert.insertAfter( formObj.find( 'legend' ) );

						formObj.find( 'button.backBtn' ).on( 'click', getSignupModal );
						$( 'div.curtain.signup div.modal form' ).unbind( 'submit' ).on( 'submit', signupSearchSubmit );
						updateModalScroll( $( 'div.curtain.signup' ) );
					}
					else
					{
						//portrait
						formObj.html('');
						formObj.append( formToInsert );
						formObj.find( 'button.backBtn' ).on( 'click', getSignupModal );
						$( 'header.portrait div.signup form' ).unbind( 'submit' ).on( 'submit', signupSearchSubmit );
					}

				}
			},
			failure  : function( ){
				window.location = '/myusapeec/signupsearch/';
			}
		});
	}

	var getSignupCaptcha = function( formObj )
	{
		$.ajax({
			url      : '/cfcs/contactGW.cfc',
			cache    : false,
			dataType : 'html',
			data     : { method : 'getCaptchaAJAX' },
			success  : function( result ){

				//$( 'div.curtain.signup div.modal div.captcha, div.curtain.signup div.modal a.audio' ).remove();
				//$( 'div.curtain.signup div.modal input[name="captchaTest"]').before( $( result ) );
				//$( 'div.curtain.signup div.modal a.audio' ).on( 'click', loadCaptcha );

				formObj.find( 'div.captcha, a.audio' ).remove();
				formObj.find( 'input[name="captchaTest"]').before( $( result ) ).val( '' );
				formObj.find( 'a.audio' ).on( 'click', loadCaptcha );
			},
			failure  : function( ){
				window.location = '/myusapeec/signupbasic/';
			}
		});
	}

	var getSignupModal = function( evt )
	{
		if( typeof evt != 'undefined' ) evt.preventDefault();
		var modalTitle = $( 'div.curtain.signup div.modal form fieldset legend' );
		modalTitle.siblings().remove();
		modalTitle = $( 'div.curtain.signup div.modal form fieldset legend' );

		// console.log("Hello World signupModal");

		//Portrait
		var portraitForm = $( 'header.portrait div.signup form' );
		//portraitForm.html('');

		$.ajax({
			url      : '/myusapeec/signupbasic/',
			cache    : false,
			dataType : 'html',
			success  : function( result ){
				var formHTML = result;

				result = result.replace( /<!DOCTYPE[\s\S]*?<body[\s\S]*?<article/i, '<article'    );
				result = result.replace( /[\s\S]*?<fieldset/i,                      '<fieldset'   );
				result = result.replace( /<\/fieldset[\s\S]*/i,                     '</fieldset>' );
				result = result.replace(/<script[^>]*>.*<\/script[^>]*>/gi,          ''           );

				$( result ).insertAfter( modalTitle );
				portraitForm.html( result );

				$( 'div.signup label' ).addClass('screenReader' );
				$( 'div.signup input' ).removeClass( 'outerLabel' );
				$( 'div.curtain.signup a.audio,        header.portrait div.signup a.audio' ).off(  'click' ).on(  'click',       loadCaptcha );
				$( 'div.curtain.signup div.modal form, header.portrait div.signup form'    ).off( 'submit' ).on( 'submit', signupBasicSubmit );

				//Makes unique ID and Label specifications for 508 compliance.
				$('div.signup label').each( function(){
					$(this).attr("for", $(this).attr("for") + 1);
				});
				$('div.signup input').each( function(){
					$(this).attr("id", $(this).attr("id") + 1);
				});
				$('header.portrait div.signup label').each( function(){
					$(this).attr("for", $(this).attr("for") + 2);
				});
				$('header.portrait div.signup input').each( function(){
					$(this).attr("id", $(this).attr("id") + 2);
				});
			},
			failure  : function( ){
				$( 'div.accountActions a.signupLink' ).unbind( 'click' ); //standard link to signup page
			}
		});
	}

	//if( hideSignupModal == false)
		//getSignupModal();

	//Set login submit button
	$( "div.curtain.login div.modal form" ).submit(function( evt ) {
		evt.preventDefault();
		evt.stopPropagation();
		loginSubmit( 'div.curtain.login div.modal form', 'modal' );
	});
	$( "header.portrait div.login form" ).submit(function( evt ) {
		evt.preventDefault();
		evt.stopPropagation();
		loginSubmit( 'header.portrait div.login form', 'mobile' );
	});

	var loginSubmit = function( formPath, formType )
	{
		//var formObj = $( 'div.curtain.login div.modal form' );
		var formObj = $( formPath );
		var toSubmit = formObj.serialize();

		var un = formObj.find( 'input[name="un"]' );
		var pw = formObj.find( 'input[name="pw"]' );

		$.ajax({
			url      : '/cfcs/contactGW.cfc',
			cache    : false,
			dataType : 'json',
			data     : toSubmit + '&method=signinAJAX' + '&removeHTML=1',
			success  : function( result ){

				if( result.RESULT == 1 )
				{
					window.location = '/myusapeec/';
				}
				else
				{
					var msgTxt = result.ERROR.MSG;

					if( formType == 'mobile' )
					{
						$( 'header.portrait div.error div' ).html( msgTxt );

						$( 'header.portrait div.error' ).addClass( 'active' ).css( 'height', $( 'header.portrait div.error div' ).height( ) + 25 + 'px' );
					}
					else
					{
						var msg = $( '<div class = "error hiddenError">' + msgTxt + '</div>' );
						formObj.find('div.error').remove( );
						formObj.find('span.errorPlaceholder').after( msg );

						msg.animate({ 'max-height':'1000px', 'opacity':'1', 'padding-top':'5px', 'padding-bottom':'5px' },500,function(){ updateModalScroll( $( 'div.curtain.signup' ) ); });
					}

				}

				if( jQuery.type( result.ERROR.UN ) === 'undefined' ){ un.removeAttr('error'); }else{ un.attr('error',''); }
				if( jQuery.type( result.ERROR.PW ) === 'undefined' ){ pw.removeAttr('error'); }else{ pw.attr('error',''); }

			},
			failure  : function( ){
				window.location = '/myusapeec/signin/';
			}
		});

	}

	var toggleCaptchaAudio = function( evt )
	{
		evt.preventDefault();
		var audioplayerid = $( this ).closest( 'form' ).find( 'div.audioplayer audio' ).attr( 'id' );
		if( $( this ).hasClass( 'play' ) ){
			document.getElementById( audioplayerid ).play();
			$( this ).removeClass( 'play' ).addClass( 'pause' ).attr( 'title', 'Pause' ).html( 'Pause' );
		}else if( $( this ).hasClass( 'pause' ) ){
			document.getElementById( audioplayerid ).pause();
			$( this ).removeClass( 'pause' ).addClass( 'play' ).attr( 'title', 'Play' ).html( 'Play' );
		}
	}

	var toggleFlashCaptchaAudio = function( evt )
	{
		evt.preventDefault();
		var audioplayer = document.getElementById( $( this ).closest( 'form' ).find( 'div.audioplayer object' ).attr( 'id' ) );
		if( $( this ).hasClass( 'play' ) && audioplayer.percentLoaded() == '100' ){
			audioplayer.SetVariable("method:play","");
			audioplayer.SetVariable( 'enabled', 'true' );
			$( this ).removeClass( 'play' ).addClass( 'pause' ).attr( 'title', 'Pause' ).html( 'Pause' );
		}else if( $( this ).hasClass( 'pause' ) ){
			audioplayer.SetVariable("method:pause","");
			audioplayer.SetVariable( 'enabled', 'false' );
			$( this ).removeClass( 'pause' ).addClass( 'play' ).attr( 'title', 'Play' ).html( 'Play' );
		}
	}

	var loadCaptcha = function( evt )
	{
		evt.preventDefault();
		var a = document.createElement('audio');
		var usingHTML5 = (a.canPlayType && a.canPlayType('audio/mpeg').replace(/no/, '') != '');
		var formToUpdate = $( this ).closest( 'form' );
		var captchaCheck = formToUpdate.find( 'input[name="captchaCheck"]' ).val();
		var hasFlash = false;
		try {
		  var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
		  if (fo) {
		    hasFlash = true;
		  }
		} catch (e) {
		  if (navigator.mimeTypes
		        && navigator.mimeTypes['application/x-shockwave-flash'] != undefined
		        && navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
		    hasFlash = true;
		  }
		}
		if( !$('link[href="/css/jquery.fayt.css"]').length ) $('head').append( '<link rel = "stylesheet" href = "/css/jquery.fayt.css" type = "text/css" />' );

		//formToUpdate.find( 'a.audio' ).replaceWith( $( '<div class="fayt" style = "position: absolute;"><span class="network active centered"></span></div>' ) );
		formToUpdate.find( 'a.audio' ).addClass( 'audioNet' ).removeClass( 'audio' ).attr( 'title', 'Loading' ).text( 'Loading' ).off( );

		$.ajax({
			url      : '/audio/audioCaptcha.cfm?captchaCheck=' + captchaCheck,
			cache    : false,
			dataType : 'html',
			success  : function( result ){
				if( result.length ){
					var canPlayTimeout = 0;
					var canPlay = function( )
					{
						clearTimeout( canPlayTimeout );
						formToUpdate.find( 'div.audioplayer audio' ).off( 'canplaythrough', canPlay );
						formToUpdate.find( 'div.audioplayer audio' ).off( 'load',           canPlay );
						//formToUpdate.find( 'div.fayt' ).replaceWith( $( '<a class="play audioControl" href="#">Play</a>' ) );
						formToUpdate.find( 'a.audioNet' ).addClass( 'play audioControl' ).removeClass( 'audioNet' ).attr( 'title', 'Play' ).text( 'Play' ).off( );
						formToUpdate.find( 'a.audioControl' ).on( 'click', toggleCaptchaAudio );
					}
					formToUpdate.find( 'div.audioplayer' ).empty().append( result );
					formToUpdate.find( 'div.audioplayer audio' ).on( 'canplaythrough', canPlay );
					formToUpdate.find( 'div.audioplayer audio' ).on( 'load',           canPlay );
					if( navigator.userAgent.match( /(iPad|iPhone|iPod)/g ))
						canPlayTimeout = setTimeout( canPlay, 5000 );
					formToUpdate.find( 'div.audioplayer audio' ).on( 'ended', function(){
						formToUpdate.find( 'a.audioControl' ).removeClass( 'pause' ).addClass( 'play' ).attr( 'title', 'Play' ).html( 'Play' );
					});
					if( !usingHTML5 ){
						if( !hasFlash ){
							formToUpdate.find( 'div.audioplayer' ).css({'height':'auto','width':'340px','padding-bottom':'10px'});
						}else{
							formToUpdate.find( 'div.audioplayer object' ).css({'height':'0','width':'0'});
						}
						setTimeout( function(){
							if( hasFlash ){
								formToUpdate.find( 'div.fayt' ).replaceWith( $( '<a class="play audioControl" href="#">Play</a>' ) );
								formToUpdate.find( 'a.audioControl' ).on( 'click', toggleFlashCaptchaAudio );
							}else{
								formToUpdate.find( 'div.fayt' ).replaceWith( $( '<a class="audio" href="#">Listen to characters from image above</a>' ) );
							}
						},1000);

						// setInterval( function(){
						// 	var audioplayer = document.getElementById( formToUpdate.find( 'div.audioplayer object' ).attr( 'id' ) );
						// 	if( audioplayer.percentLoaded() == '100' && !audioplayer.isPlaying() ){
						// 		formToUpdate.find( 'a.audioControl' ).removeClass( 'pause' ).addClass( 'play' ).attr( 'title', 'Play' ).html( 'Play' );
						// 	}
						// },1000);
					}

					if( formToUpdate.closest('div.curtain.signup').length ) updateModalScroll( $( 'div.curtain.signup' ) );
					//formToUpdate.find( 'a.audio' ).unbind( 'click' ).on( 'click', function(evt){ evt.preventDefault(); } );
				}else{
					formToUpdate.find( 'div.fayt' ).replaceWith( $( '<a class="audio" href="#">Listen to characters from image above</a>' ) );
					formToUpdate.find( 'a.audio' ).on( 'click', loadCaptcha );
					alert( 'The audio message could not be generated.' );
				}
			},
			failure  : function( ){
				formToUpdate.find( 'div.fayt' ).replaceWith( $( '<a class="audio" href="#">Listen to characters from image above</a>' ) );
				formToUpdate.find( 'a.audio' ).on( 'click', loadCaptcha );
				alert( 'The audio message could not be generated.' );
			}
		});
	}
	$( 'a.audio' ).unbind( 'click' ).on( 'click', loadCaptcha );

	$('.skipLink').focus(function(){
		$(this).parent('div').css('top', 0);
	}).blur(function(){
		$(this).parent('div').css('top', -30 + 'px');
	});

	$( 'footer a.viewFull' ).on( 'click touchend', function( evt ){
		var toResponsive = $( this ).hasClass( 'backToResponsive' );
		evt.preventDefault( );
		$.ajax({
			url      : '/cfcs/respond.cfc',
			cache    : false,
			dataType : 'json',
			data     : {
				method       : 'setFlagByAJAX',
				toResponsive : toResponsive
			},
			success  : function( result ){
				if( result ){
					if( toResponsive ){ jQuery('html').addClass( 'responsive' ); $('ul.landingSlides').css('height','0px'); }else{ jQuery('html').removeClass( 'responsive' ); }
					if( typeof updateInfoBoxes == 'function' ){ updateInfoBoxes(); }
					jQuery('html,body').animate({scrollTop:0},500);
					if( navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints > 0 ){ window.scrollTo(0,0); }
					$(window).trigger('resize');
				}
				updateSideNav();
			}
		});
	});

	var toggleSideNav = function( ) {
		var isActive = $( 'div.sideNav div.ctaHeader' ).hasClass( 'active' );

		if( isActive ) {
			document.cookie = 'sideNavState=open;path=/';
		} else {
			document.cookie = 'sideNavState=closed;path=/';
		}
	}

	var setCTA = function( ) {
		var cookieScope  = getCookieScope( );
		var sideNavState = cookieScope.sideNavState;

		$( 'div.showHideBox div.ctaDesc' ).each( function( ) {
			var active    = $( this ).hasClass( 'active' );
			var isSideNav = $( this ).parent( ).hasClass( 'sideNav' );

			if( isSideNav && sideNavState == 'open' ){
				if( !active ){
					$( this ).addClass( 'active' );
					$( this ).siblings( 'div.ctaHeader' ).addClass( 'active' );
				}
				// $( this ).css( 'height', 'auto' ).attr( 'data-height', $( this ).outerHeight( )).css( 'height', $( this ).outerHeight( ));
			}
			// else if( active ) {
			// 	$( this ).css( 'height', 'auto' ).attr( 'data-height', $( this ).outerHeight( )).css( 'height', $( this ).outerHeight( ));
			// }
			else {
				// $( this ).addClass( 'active' ).delay(250).attr( 'data-height', $( this ).outerHeight( )).removeClass( 'active' );
				$( this ).removeClass( 'active' );
			}
		});
	};

	// $( window ).on( 'resize orientationchange', setCTA );
	setCTA( );

	var toggleCTA = function( evt )
	{
		evt.preventDefault( );

		var link   = $( this );
		var header = link.parent( 'div.ctaHeader' );
		var active = header.hasClass( 'active' );
		var ctaBox = header.next( 'div.ctaDesc' );
		var height = $(this ).parent().next( 'div.ctaDesc' ).attr( 'data-height' );
		var isSideNav = link.parent( ).parent( ).hasClass( 'sideNav' );

		if( active )
		{
			link.attr( 'title', 'Expand' );
			// ctaBox.css( 'height', '' );
		}
		else
		{
			link.attr( 'title', 'Collapse' );
			// ctaBox.css( 'height', height );
		}

		header.toggleClass( 'active' );
		ctaBox.toggleClass( 'active' );

		if( isSideNav ) toggleSideNav( );

	};
	$( 'div.cta.showHideBox div.ctaHeader span.chevron' ).on( 'click', toggleCTA );

	$( window ).on( 'load resize orientationchange', updateSideNav );

	var updateSideNav = function( evt )
	{
		var rightAside = $( 'html.responsive aside.rightAside' );
		var sideNav = rightAside.children('div.sideNav');
		var mainContent = $( 'html.responsive article.mainContent' );
		if( sideNav.length == 1 && rightAside.children().length == 1 && !sideNav.is( ':visible' ) ){
			rightAside.addClass( 'removed' );
			mainContent.removeClass( 'span_7_12' ).addClass( 'span_12_12' );
		}else{
			rightAside.removeClass( 'removed' );
			mainContent.removeClass( 'span_12_12' ).addClass( 'span_7_12' );
		}
	}

	var setFilterHeight = function( ) {
		$( 'div.searchFilters:not(.open)' ).each( function( ) {
			var active = $( this ).hasClass( 'active' );

			if( active ) {
				$( this ).css( 'height', 'auto' ).attr( 'data-height', $( this ).height( )).css( 'height', $( this ).height( ));
			} else {
				$( this ).addClass( 'active' ).attr( 'data-height', $( this ).height( )).removeClass( 'active' );
			}
		});
	}

	setFilterHeight( );
	$( window ).on( 'load resize orientationchange', setFilterHeight );

	var toggleFilters = function( evt )
	{
		evt.preventDefault( );

		var link    = $( this );
		var active  = link.hasClass( 'active' );
		var filters = $( 'div.searchFilters:not(.open)' );
		var height  = filters.attr( 'data-height' );

		if( active )
		{
			link.attr( 'title', 'Expand' );
			filters.css( 'height', '' );
		}
		else
		{
			link.attr( 'title', 'Collapse' );
			filters.css( 'height', height );
		}

		link.toggleClass( 'active' );
		filters.toggleClass( 'active' );

	};

	$( 'div.mobile a.searchHeader' ).on( 'click', toggleFilters );

	if( exitPreview == 1 )
		displayWarningBanner( 'Your Event Registration Preview has ended. Please navigate to the Event Detail page or Back Office Event Information tab to start another preview.' );
});

/* Slide in animation on scroll */
var animateSlideIn = function( ) {
	$(".animationElement.slideLeft,.animationElement.slideRight").each(function(i, el) {
		var el = $(el);
		if (el.visible(false)) {
			el.addClass("inView");
		}
	});
}
$(window).scroll(animateSlideIn);
$(document).ready(animateSlideIn);

/* visibility plugin. used in scroll animation */
(function($) {

  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function(partial) {

	  var $t            = $(this),
		  $w            = $(window),
		  viewTop       = $w.scrollTop(),
		  viewBottom    = viewTop + $w.height(),
		  _top          = $t.offset().top,
		  _bottom       = _top + $t.height(),
		  compareTop    = partial === true ? _bottom : _top,
		  compareBottom = partial === true ? _top : _bottom;

	return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };

})(jQuery);

var captchaListener = new Object( );

captchaListener.onInit = function( )
{
	$( 'object.flashAudio' ).get( 0 ).SetVariable( 'method:setUrl', $( '.flashAudio' ).attr( 'data-mp3' ));
};

captchaListener.onUpdate = function( )
{
	if( 'false' == this.isPlaying )
		$( 'a.audioControl' ).trigger( 'click' );
};
